import React, { forwardRef } from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import {
  format,
  getYear,
  getMonth,
  eachYearOfInterval,
  subYears,
  isSameISOWeek,
  isSameWeek,
  startOfWeek,
  endOfWeek,
} from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

import { ReactComponent as CalendarIcon } from "../../../build/images/icons/Calendar.svg";
import { ReactComponent as CalendarIconV2 } from "../../../build/images/icons/calendar-icon-v2.svg";

import "./date-range.css";

export default function DateRange({
  selected,
  setDate,
  selectRangeType,
  startDate,
  endDate,
  minDate,
  maxDate,
  dateFormat,
  showWeekPicker = false,
  showMonthYearPicker = false,
  showYearPicker = false,
  isIconV2 = false,
}) {
  //GENERAL
  registerLocale("pt-BR", ptBR);
  setDefaultLocale("pt-BR");

  const years = eachYearOfInterval({
    start: subYears(new Date(), 10),
    end: new Date(),
  });

  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  //STATES

  //REDUX - Selectors

  //FUNCTIONS
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="input-date-range" onClick={onClick} ref={ref}>
      {showWeekPicker
        ? `${format(startOfWeek(selected), "dd")} - ${format(
            endOfWeek(selected),
            "dd 'de' MMMM 'de' yyyy",
            { locale: ptBR }
          )}`
        : value}
      {isIconV2 ? <CalendarIconV2 /> : <CalendarIcon />}
    </div>
  ));

  //USE EFFECTS

  return (
    <div className="date-range-custom">
      <DatePicker
        selected={selected}
        onChange={(date) => setDate(date)}
        startDate={startDate}
        endDate={endDate}
        minDate={minDate}
        maxDate={maxDate}
        openToDate={null}
        selectsStart={selectRangeType === "start"}
        selectsEnd={selectRangeType === "end"}
        showPopperArrow={false}
        dateFormat={dateFormat}
        locale="pt-BR"
        customInput={<CustomInput />}
        showWeekPicker={showWeekPicker}
        showMonthYearPicker={showMonthYearPicker}
        showYearPicker={showYearPicker}
        dayClassName={(date) =>
          isSameWeek(date, selected) && showWeekPicker
            ? "react-datepicker__day--selected"
            : ""
        }
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          customHeaderCount,
          decreaseMonth,
          increaseMonth,
          increaseYear,
          decreaseYear,
        }) => {
          return (
            <div className={showYearPicker ? "height-header" : ""}>
              {!showMonthYearPicker && (
                <button
                  aria-label="Previous Month"
                  className={
                    "react-datepicker__navigation react-datepicker__navigation--previous"
                  }
                  style={
                    customHeaderCount === 1 ? { visibility: "hidden" } : null
                  }
                  onClick={showYearPicker ? decreaseYear : decreaseMonth}
                >
                  <span
                    className={
                      "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
                    }
                  >
                    {"<"}
                  </span>
                </button>
              )}
              {!showYearPicker && (
                <div className="date-range-inputs">
                  {!showMonthYearPicker && (
                    <select
                      value={months[getMonth(date)]}
                      onChange={({ target: { value } }) =>
                        changeMonth(months.indexOf(value))
                      }
                    >
                      {months.map((month, key) => (
                        <option key={key} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  )}

                  <select
                    value={getYear(date)}
                    onChange={({ target: { value } }) => changeYear(value)}
                  >
                    {years.map((year, key) => (
                      <option key={key} value={format(year, "uuuu")}>
                        {format(year, "uuuu")}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {!showMonthYearPicker && (
                <button
                  aria-label="Next Month"
                  className={
                    "react-datepicker__navigation react-datepicker__navigation--next"
                  }
                  style={
                    customHeaderCount === 1 ? { visibility: "hidden" } : null
                  }
                  onClick={showYearPicker ? increaseYear : increaseMonth}
                >
                  <span
                    className={
                      "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
                    }
                  >
                    {">"}
                  </span>
                </button>
              )}
            </div>
          );
        }}
      />
    </div>
  );
}

// import React, { forwardRef, useState, useEffect } from "react";
// import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
// import {
//   format,
//   getYear,
//   getMonth,
//   eachYearOfInterval,
//   subYears,
//   isSameISOWeek,
//   isSameWeek,
//   startOfWeek,
//   endOfWeek,
// } from "date-fns";
// import ptBR from "date-fns/locale/pt-BR";

// import { ReactComponent as CalendarIcon } from "../../../build/images/icons/Calendar.svg";

// import "./date-range.css";

// export default function DateRange({
//   selected: propSelected,
//   setDate,
//   selectRangeType,
//   startDate: propStartDate,
//   endDate: propEndDate,
//   minDate: propMinDate,
//   maxDate: propMaxDate,
//   dateFormat,
//   showWeekPicker = false,
//   showMonthYearPicker = false,
//   showYearPicker = false,
// }) {
//   //GENERAL
//   registerLocale("pt-BR", ptBR);
//   setDefaultLocale("pt-BR");

//   const [selected, setSelected] = useState(propSelected || new Date());
//   const [startDate, setStartDate] = useState(propStartDate || null);
//   const [endDate, setEndDate] = useState(propEndDate || null);
//   const [minDate, setMinDate] = useState(propMinDate || null);
//   const [maxDate, setMaxDate] = useState(propMaxDate || null);

//   useEffect(() => {
//     setSelected(propSelected || new Date());
//     setStartDate(propStartDate || null);
//     setEndDate(propEndDate || null);
//     setMinDate(propMinDate || null);
//     setMaxDate(propMaxDate || null);
//   }, [propSelected, propStartDate, propEndDate, propMinDate, propMaxDate]);

//   const years = eachYearOfInterval({
//     start: subYears(new Date(), 10),
//     end: new Date(),
//   });

//   const months = [
//     "Janeiro",
//     "Fevereiro",
//     "Março",
//     "Abril",
//     "Maio",
//     "Junho",
//     "Julho",
//     "Agosto",
//     "Setembro",
//     "Outubro",
//     "Novembro",
//     "Dezembro",
//   ];

//   //STATES

//   //REDUX - Selectors

//   //FUNCTIONS
//   const CustomInput = forwardRef(({ value, onClick }, ref) => (
//     <div className="input-date-range" onClick={onClick} ref={ref}>
//       {showWeekPicker
//         ? `${format(startOfWeek(selected), "dd")} - ${format(
//           endOfWeek(selected),
//           "dd 'de' MMMM 'de' yyyy",
//           { locale: ptBR }
//         )}`
//         : value}
//       <CalendarIcon />
//     </div>
//   ));

//   //USE EFFECTS

//   return (
//     <div className="date-range-custom">
//       <DatePicker
//         selected={selected}
//         onChange={(date) => setDate(date)}
//         startDate={startDate}
//         endDate={endDate}
//         minDate={minDate}
//         maxDate={maxDate}
//         selectsStart={selectRangeType === "start"}
//         selectsEnd={selectRangeType === "end"}
//         showPopperArrow={false}
//         dateFormat={dateFormat}
//         locale="pt-BR"
//         customInput={<CustomInput />}
//         showWeekPicker={showWeekPicker}
//         showMonthYearPicker={showMonthYearPicker}
//         showYearPicker={showYearPicker}
//         dayClassName={(date) =>
//           isSameWeek(date, selected) && showWeekPicker
//             ? "react-datepicker__day--selected"
//             : ""
//         }
//         renderCustomHeader={({
//           date,
//           changeYear,
//           changeMonth,
//           customHeaderCount,
//           decreaseMonth,
//           increaseMonth,
//           increaseYear,
//           decreaseYear,
//         }) => {
//           return (
//             <div className={showYearPicker ? "height-header" : ""}>
//               {!showMonthYearPicker && (
//                 <button
//                   aria-label="Previous Month"
//                   className={
//                     "react-datepicker__navigation react-datepicker__navigation--previous"
//                   }
//                   style={
//                     customHeaderCount === 1 ? { visibility: "hidden" } : null
//                   }
//                   onClick={showYearPicker ? decreaseYear : decreaseMonth}
//                 >
//                   <span
//                     className={
//                       "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
//                     }
//                   >
//                     {"<"}
//                   </span>
//                 </button>
//               )}
//               {!showYearPicker && (
//                 <div className="date-range-inputs">
//                   {!showMonthYearPicker && (
//                     <select
//                       value={months[getMonth(date)]}
//                       onChange={({ target: { value } }) =>
//                         changeMonth(months.indexOf(value))
//                       }
//                     >
//                       {months.map((month, key) => (
//                         <option key={key} value={month}>
//                           {month}
//                         </option>
//                       ))}
//                     </select>
//                   )}

//                   <select
//                     value={getYear(date)}
//                     onChange={({ target: { value } }) => changeYear(value)}
//                   >
//                     {years.map((year, key) => (
//                       <option key={key} value={format(year, "uuuu")}>
//                         {format(year, "uuuu")}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               )}
//               {!showMonthYearPicker && (
//                 <button
//                   aria-label="Next Month"
//                   className={
//                     "react-datepicker__navigation react-datepicker__navigation--next"
//                   }
//                   style={
//                     customHeaderCount === 1 ? { visibility: "hidden" } : null
//                   }
//                   onClick={showYearPicker ? increaseYear : increaseMonth}
//                 >
//                   <span
//                     className={
//                       "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
//                     }
//                   >
//                     {">"}
//                   </span>
//                 </button>
//               )}
//             </div>
//           );
//         }}
//       />
//     </div>
//   );
// }
